import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FadeUp, SectionTag } from "../components/site/Reveal";

const FAQS = [
  {
    cat: "The Program",
    items: [
      { q: "Who is The Back Office Blueprint for?", a: "Owner-operated and small service businesses that already have paying customers — residential and commercial cleaning, window cleaning, pressure washing, handyman and maintenance, mobile detailing, landscaping, painting, junk removal, and similar hands-on trades. If you're still doing the physical work AND all the admin, you're exactly who this is built for." },
      { q: "Is this done-for-you? Will you set everything up for me?", a: "No — and that's deliberate. This is guided implementation: we provide the training, templates, workflows, coaching, and accountability, and you build each system in your own business. When we're done, you own it and can run it without us." },
      { q: "How much time does it take each week?", a: "Plan for 2–4 focused hours per week for 7 weeks: one module lesson set, one live call, and implementation time on your real business. The program is designed for people who are also working jobs." },
      { q: "What do I walk away with?", a: "Seven working systems installed in your business: lead capture, estimates, scheduling, customer records, invoicing, payments, and follow-up — plus the full template vault and continued WorkBase Hub access." },
    ],
  },
  {
    cat: "Software & Tools",
    items: [
      { q: "Do I have to buy specific software?", a: "No. We start with the simplest tool that works — often what you already have plus free tiers of common tools. Where software genuinely helps (payments, booking), we recommend options and you choose. Nothing is locked in." },
      { q: "I'm not technical. Will I keep up?", a: "Yes. Every workflow is designed to be maintained by someone on a job site, in minutes a day. If you can send a text and use a spreadsheet, you can run these systems." },
    ],
  },
  {
    cat: "Enrollment & Payment",
    items: [
      { q: "How does enrollment work?", a: "Apply (free, ~5 minutes) → we review by hand within 2 business days → if accepted, you enroll in the Founding Cohort at $497 paid in full or 2 monthly payments of $275 → WorkBase Hub unlocks and your cohort begins. No payment is required to apply." },
      { q: "Is there a guarantee?", a: "Yes — a 14-day fit guarantee. If within 14 days of your cohort start you decide it's not right, email us and we'll refund you in full. See the Refund Policy for details." },
      { q: "Why an application instead of open signup?", a: "Cohorts are small and the coaching is direct. We only accept operators we're confident we can help — applying protects your money and everyone's time." },
    ],
  },
];

export default function Faq() {
  return (
    <div data-testid="faq-page" className="bg-navy pt-16 min-h-screen">
      <section className="blueprint-grid grain">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-24 sm:py-28">
          <FadeUp>
            <SectionTag dark>FAQ // Straight Answers</SectionTag>
            <h1 className="font-display font-extrabold tracking-tight text-white text-4xl sm:text-5xl mt-6">
              Asked by operators like you.
            </h1>
          </FadeUp>
          <div className="mt-14 space-y-12">
            {FAQS.map((group) => (
              <FadeUp key={group.cat}>
                <p className="font-mono text-xs uppercase tracking-[0.22em] text-safety mb-4">[{group.cat}]</p>
                <Accordion type="single" collapsible className="border border-white/10">
                  {group.items.map((item, i) => (
                    <AccordionItem key={i} value={`${group.cat}-${i}`} className="border-white/10 bg-charcoal/50 px-6">
                      <AccordionTrigger
                        data-testid={`faq-q-${group.cat.toLowerCase().replace(/[\s&]+/g, "-")}-${i}`}
                        className="text-white font-display font-semibold text-left hover:text-safety hover:no-underline"
                      >
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-slate-400 text-sm leading-relaxed">
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
